const AppBar = require('./AppBar/standalone');

AppBar.mount();



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/standalone.es6
 **/